/* global axios */
import ApiClient from './ApiClient';

class WebPhoneAPI extends ApiClient {
  constructor() {
    super('web_phone', { accountScoped: true });
  }

  click_to_call({ callee }) {
    return axios.post(`${this.url}/click_to_call`, {
      callee,
    });
  }
}

export default new WebPhoneAPI();
